<template>
    <div class="buy-billing">
      <NavBar />
      <div id="main">
        <p id="remaining-hours"> Current Remaining Hours: 5 hr 53 min </p>
        <p class="section-title"> Usage History & Billing </p>
          <!-- TODO: Pull Data from DB -->
          <table>
            <tr>
              <th>Date</th>
              <th>Item</th>
              <th>Duration</th>
              <th>Remaining Hours</th>
            </tr>
            <tr>
              <td>3/28/2021</td>
              <td>Tutoring Session with Alexander Stoddard <br/> Type: Video Call</td>
              <td>1 hr 30 min</td>
              <td>5 hr 53 min</td>
            </tr>
          </table>
        <button> Buy Session Credit </button>
      </div>
    </div>
  </template>
<script>
import NavBar from './../components/NavBar.vue'

export default {
  components: {
    NavBar
  }
}
</script>
  <style scoped>
  #main {
    display: flex;
    flex-direction: column;
    align-items: center;
    
  height: 100vh;
  }
  #remaining-hours {
    font-weight: bold;
    color: #3867AE;
    font-size: x-large;
  }
  .section-title {
    text-transform: uppercase;
    letter-spacing: 0.1ch;
    color: #3867AE;
    font-weight: bold;
    width: 100%;
  }
  table {
    background-color: white;
    border-radius: 25px;
    padding: 1vw;
    margin: 1vw;
    width: 100%;
  }
  th {
    border-bottom: 1px solid black;
  }
  td {
    padding: 1vw;
    text-align: center;
  }
  button {
  background-color: #FFD966;
  height: 4.75vh;
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  padding: 0px 20px;
  border-radius: 5px;
}
</style>
  